import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        stroke="#303330"
        d="m10.346 5.01.115.248.271.037 4.372.596c.282.076.374.182.411.33.053.212.02.362-.104.56l-3.159 3.06-.187.18.041.257.7 4.4.004.022.005.021c.021.086.009.139-.012.18a.51.51 0 0 1-.18.183c-.129.086-.341.106-.533.051l-3.862-1.98-.234-.12-.231.125-3.9 2.1-.02.01-.02.014c-.026.017-.07.033-.152.021a.743.743 0 0 1-.294-.121.519.519 0 0 1-.173-.206c-.034-.074-.03-.114-.03-.12 0 0 0-.001 0 0l.013-.039.007-.04.7-4.4.04-.247-.175-.18-3.1-3.2-.005-.006c-.193-.192-.209-.4-.18-.488.043-.127.196-.301.424-.367l4.37-.596.261-.035.118-.236 2-4 .016-.032.011-.034a.421.421 0 0 1 .13-.184A.305.305 0 0 1 8 .7c.195 0 .344.083.464.249l1.882 4.061Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export { SvgComponent as Star };
